const STORAGE_KEY = 'selectedProduct';

export const saveSelectedProduct = (product) => {
  if (typeof window === 'undefined' || !product) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(product));
  } catch {
    // ignore
  }
};

export const getSelectedProduct = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearSelectedProduct = () => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
